var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHolidayVillage = function SvgHolidayVillage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-160v-400l240-240 240 240v400zm80-80h120v-120h80v120h120v-287L320-687 160-527zm120-200v-80h80v80zm360 280v-433L433-800h113l174 174v466zm160 0v-499L659-800h113l108 108v532zm-640-80h320z"
  })));
};
export default SvgHolidayVillage;